import React from 'react';

export function LinearRatingIcon(props: React.SVGAttributes<any>) {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#clip0_6536_10385)">
                <path
                    d="M1.90047 14.512V12.4L7.66047 10.96V28H5.62047V13.408L1.90047 14.512ZM10.9052 23.2V21.4H15.7052V23.2H10.9052ZM17.7442 14.512V12.4L23.5042 10.96V28H21.4642V13.408L17.7442 14.512ZM29.6289 19.6C29.6289 20.576 29.7249 21.48 29.9169 22.312C30.1089 23.128 30.3889 23.84 30.7569 24.448C31.1249 25.04 31.5649 25.504 32.0769 25.84C32.6049 26.16 33.1889 26.32 33.8289 26.32C34.4849 26.32 35.0689 26.16 35.5809 25.84C36.0929 25.504 36.5329 25.04 36.9009 24.448C37.2689 23.84 37.5489 23.128 37.7409 22.312C37.9329 21.48 38.0289 20.576 38.0289 19.6C38.0289 18.624 37.9329 17.728 37.7409 16.912C37.5489 16.08 37.2689 15.368 36.9009 14.776C36.5329 14.168 36.0929 13.704 35.5809 13.384C35.0689 13.048 34.4849 12.88 33.8289 12.88C33.1889 12.88 32.6049 13.048 32.0769 13.384C31.5649 13.704 31.1249 14.168 30.7569 14.776C30.3889 15.368 30.1089 16.08 29.9169 16.912C29.7249 17.728 29.6289 18.624 29.6289 19.6ZM27.5889 19.6C27.5889 17.92 27.8529 16.432 28.3809 15.136C28.9089 13.84 29.6369 12.824 30.5649 12.088C31.5089 11.336 32.5969 10.96 33.8289 10.96C35.0609 10.96 36.1409 11.336 37.0689 12.088C38.0129 12.824 38.7489 13.84 39.2769 15.136C39.8049 16.432 40.0689 17.92 40.0689 19.6C40.0689 21.28 39.8049 22.768 39.2769 24.064C38.7489 25.36 38.0129 26.384 37.0689 27.136C36.1409 27.872 35.0609 28.24 33.8289 28.24C32.5969 28.24 31.5089 27.872 30.5649 27.136C29.6369 26.384 28.9089 25.36 28.3809 24.064C27.8529 22.768 27.5889 21.28 27.5889 19.6Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_6536_10385">
                    <rect width="40" height="40" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
